import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contracts_editorService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { contractId: number }): 
  Promise<{ result: { Id?: number, AccountId?: number, AutoRenewalPercentage?: number, AutoRenewalTypeId?: number, ContainsPortalVisibleAttachments?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, CurrencyId?: number, EndDate?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Notes?: string, ProjectId?: number, StartDate?: string, StatusId?: number, TaxScheduleId?: number, TermId?: number, Account?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, Status?: { Name?: string }, AutoRenewalType?: { Name?: string }, Currency?: { Label?: string }, TaxSchedule?: { Label?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.contractId)) {
      missingRequiredInParams.push('\'contractId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contracts_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      contractId: number    }) {
        if(isNil(inParams.contractId)) {
          return true; 
        }
      return false;
    }
}
